import { render } from "./DriverTable.vue?vue&type=template&id=7897e98c&scoped=true"
import script from "./DriverTable.vue?vue&type=script&lang=js"
export * from "./DriverTable.vue?vue&type=script&lang=js"

import "./DriverTable.vue?vue&type=style&index=0&id=7897e98c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7897e98c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTd});
